/* frontend/src/utils/manufacturers.js */
export const MANUFACTURERS = [
  'Acura',
  'Agrale',
  'Alfa Romeo',
  'AM Gen',
  'Asia Motors',
  'ASTON MARTIN',
  'Audi',
  'Baby',
  'BMW',
  'BRM',
  'Bugre',
  'BYD',
  'CAB Motors',
  'Cadillac',
  'Caoa Chery',
  'Caoa Chery/Chery',
  'CBT Jipe',
  'CHANA',
  'CHANGAN',
  'Chevrolet',
  'Chrysler',
  'Citroën',
  'Cross Lander',
  'D2D Motors',
  'Daewoo',
  'Daihatsu',
  'DFSK',
  'Dodge',
  'EFFA',
  'Engesa',
  'Envemo',
  'Ferrari',
  'FEVER',
  'Fiat',
  'Fibravan',
  'Ford',
  'FOTON',
  'Fyber',
  'GAC',
  'GEELY',
  'GREAT WALL',
  'Gurgel',
  'GWM',
  'HAFEI',
  'HITECH ELECTRIC',
  'Honda',
  'Hyundai',
  'Isuzu',
  'IVECO',
  'JAC',
  'Jaecoo',
  'Jaguar',
  'Jeep',
  'JINBEI',
  'JPX',
  'Kia Motors',
  'Lada',
  'LAMBORGHINI',
  'Land Rover',
  'Lexus',
  'LIFAN',
  'LOBINI',
  'Lotus',
  'Mahindra',
  'Maserati',
  'Matra',
  'Mazda',
  'Mclaren',
  'Mercedes-Benz',
  'Mercury',
  'MG',
  'MINI',
  'Mitsubishi',
  'Miura',
  'NETA',
  'Nissan',
  'Omoda',
  'Peugeot',
  'Plymouth',
  'Pontiac',
  'Porsche',
  'RAM',
  'RELY',
  'Renault',
  'Rolls-Royce',
  'Rover',
  'Saab',
  'Saturn',
  'Seat',
  'SERES',
  'SHINERAY',
  'smart',
  'SSANGYONG',
  'Subaru',
  'Suzuki',
  'TAC',
  'Toyota',
  'Troller',
  'Volvo',
  'Volkswagen',
  'Wake',
  'Walk',
  'ZEEKR'
];